import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainPage from "./Components/MainPage";
import styled from "styled-components";
import { color } from "./Utils/Constant";

const AppContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  margin-top: 10px;
  background: ${color.white}; 
    
`;

function AppStack() {
  return (
    <AppContainer>
      <Router>
        <Routes>
          <Route path="/" element={<MainPage />} />
        </Routes>
      </Router>
    </AppContainer>
  );
}

export default AppStack;
